export const MODE_FIELD = '_mode';
export const EMPTY_PLACEHOLDER = '-';
export const EXCEL_FILE_NAME = 'lhrTable.xlsx';

export enum Mode {
  show = 'show',
  add = 'add',
  edit = 'edit',
}
